import { SlotGameType1_2 } from "../SlotGameType1_2";

// namespace SlotGames2
// {
	export class RoyalKing2 extends SlotGameType1_2
	{  		
	}
	
// }